/**
 * ConsentCheckbox — required GDPR/Loi 2019-014 affirmation for all waitlist
 * (PII) forms. Renders a checkbox paired with a label that links to the
 * terms and privacy pages.
 *
 * The label text contains inline anchor elements and therefore cannot be
 * sourced from the compile-fr.mjs i18n pipeline (which strips all HTML tags).
 * The plain-text copy is registered in the copy deck under marketing.consent.label
 * for record-keeping; the JSX rendered here matches that copy with links added.
 *
 * useId() produces a unique id per instance so that all three waitlist forms
 * (Hero, Worker, Closing) each have their own checkbox binding — clicking the
 * consent label in one form does not toggle a different form's checkbox.
 */

import { useId } from 'react';
import styles from './ConsentCheckbox.module.css';

export function ConsentCheckbox({
  locale,
  checked,
  onChange,
}: {
  locale: 'fr' | 'en';
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  const id = useId();
  return (
    <div className={styles.consent}>
      <input
        id={id}
        type="checkbox"
        required
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={styles.checkbox}
      />
      <label htmlFor={id} className={styles.label}>
        {locale === 'fr' ? (
          <>
            {"J'accepte les "}
            <a href="/conditions">conditions</a>
            {' et la '}
            <a href="/confidentialite">politique de confidentialité</a>
            {'.'}
          </>
        ) : (
          <>
            {'I accept the '}
            <a href="/terms">terms</a>
            {' and '}
            <a href="/privacy">privacy policy</a>
            {'.'}
          </>
        )}
      </label>
    </div>
  );
}
